import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { login } from "services/auth_service";

import SelectLanguage from "components/selectLanguage";
import RecoverPass from "components/Recoverpass";
import Register from "components/Register";

import logo from "img/FS_logotipo_beta.png";

import config from "config.json";

function App({ refresh }) {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [failure, setFailure] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [displayedTab, setDisplayedTab] = useState("login");

  const changePassFunc = (evt) => {
    setPassword(evt.target.value);
  };

  const changeEmailFunc = (evt) => {
    setEmail(evt.target.value);
  };

  const isEmailValid = () => {
    const EMAIL_REGEX_VAL = new RegExp(config.EMAIL_REGEX_VALIDATOR, "i");
    return EMAIL_REGEX_VAL.test(email) ? true : false;
  };

  const isPasswordValid = () => {
    return password.length < config.MIN_PASSWORD_CHAR ? false : true;
  };

  const setActiveTab = (tab = "login") => {
    if (tab === "login") {
      setDisplayedTab("login");
    } else if (tab === "register") {
      setDisplayedTab("register");
    } else {
      setDisplayedTab("recover-pass");
    }
  };

  const loginFunc = async () => {
    setErrorMsg([]);

    if (!isEmailValid()) {
      setFailure(true);
      setErrorMsg(t("ERROR_invalid_email"));
      return;
    }

    if (!isPasswordValid()) {
      setFailure(true);
      setErrorMsg(t("ERROR_pass_min_length", { chars: config.MIN_PASSWORD_CHAR }));
      return;
    }

    try {
      await login(email, password);
      refresh();
    } catch (exception) {
      console.log("🚀 ~ file: Login.js:69 ~ loginFunc ~ exception:", exception)
      setFailure(true);

      if (
        exception &&
        exception.response &&
        exception.response.data &&
        exception.response.data.error &&
        exception.response.data.error.message ===
          "Your account email is not confirmed"
      ) {
        setErrorMsg("ERROR_pass_min_length", { chars: config.MIN_PASSWORD_CHAR });
        setErrorMsg(t("ERROR_unactivated_account"));
        return;
      }

      setErrorMsg(t("ERROR_login_failed"));
    }
  };

  const canSubmitLogin = () => {
    return password.length > 7 && isEmailValid();
  };

  return (


    <div className="login">
        <div className="login-side">
          <section className="section logo" style={{ display: "flex" }}>
            <img src={logo} alt="" style={{ height: "125px", width: "500px" }} />
            <div style={{ margin: "0.5rem 1.5rem" }}>
              <SelectLanguage className="is-active"> </SelectLanguage>
            </div>
          </section>

          <div className="column">
            {displayedTab === "login" && (
              <>
                <div className="block">
                  <h1 className="title is-3">{t("welcome_back")}</h1>
                  <h2 className="subtitle is-6">
                    {t("enter_details")}.
                  </h2>
                </div>

                <div className="block">
                  <div className="field">
                    <p className="control has-icons-left has-icons-right">
                      <input
                        className="input "
                        type="email"
                        value={email}
                        onChange={(evt) => changeEmailFunc(evt)}
                        placeholder="Email"
                      />
                      <span className="icon is-small is-left">
                        <i className="fas fa-envelope"></i>
                      </span>
                    </p>
                  </div>
                </div>
                <div className="block">
                  <div className="field">
                    <p className="control has-icons-left">
                      <input
                        className="input"
                        type="password"
                        value={password}
                        onChange={(evt) => changePassFunc(evt)}
                        placeholder="Password"
                      />
                      <span className="icon is-small is-left">
                        <i className="fas fa-lock"></i>
                      </span>
                    </p>
                  </div>
                </div>
                <div className="block">
                  <label className="checkbox">
                    <input type="checkbox" />
                    {t("remember")}
                  </label>
                  <Link
                    onClick={() => setActiveTab("recover-pass")}
                    className="is-small"
                    style={{ float: "right" }}
                  >
                    {t("recover_password")}
                  </Link>
                </div>
                <div className="block">
                  <button
                    className="button btn1 is-link is-fullwidth"
                    type="submit"
                    onClick={loginFunc}
                    disabled={!canSubmitLogin()}
                  >
                    {t("enter")}
                  </button>
                </div>
                <div className="block">
                  <p className="is-small">
                    {t("dont_have_account")}{" "}
                    <Link
                    onClick={() => setActiveTab("register")}
                    className="is-small"
                    style={{ float: "right" }}
                  >
                    {t("register")}
                  </Link>
                  </p>
                </div>
                <div className="block">
                  {failure && (
                    <div className="block">
                      <article className="message is-warning">
                        <div className="message-body">{errorMsg}</div>
                      </article>
                    </div>
                  )}
                </div>
              </>
            )}

            {displayedTab === "recover-pass" && (
              <>
                <RecoverPass setActiveTab={setActiveTab} />
              </>
            )}

            {displayedTab === "register" && (
              <>
                <Register setActiveTab={setActiveTab} />
              </>
            )}
          </div>
        
      </div>
    </div>
  );
}

export default App;
